module.exports = __webpack_public_path__ + "img/32e0129.png";